import React from 'react';
import Icon from './UI/Icon';
import './Specializations.css';

const specialitiesData = [
  {
    id: 'ortho',
    title: 'Ortho Rehabilitation',
    subtitle: 'Joints & Bones Care',
    description: 'Expert diagnostics and targeted therapies for structural and musculoskeletal conditions, helping restore joint fluidity and overall body alignment.',
    icon: 'activity',
    image: '/assets/ser_cat1.png',
    conditions: [
      'Osteoarthritis & Rheumatoid Arthritis',
      'Frozen Shoulder & Tennis Elbow',
      'Cervical Spondylitis & Low Back Pain',
      'Sacroiliitis & Tail Bone Pain'
    ],
    themeColor: 'teal'
  },
  {
    id: 'neuro',
    title: 'Neuro Rehabilitation',
    subtitle: 'Nerve & Spine Care',
    description: 'Advanced neurological therapy programs designed to rebuild motor pathways, enhance neurological coordination, and restore physical independence.',
    icon: 'shield',
    image: '/assets/ser_cat2.png',
    conditions: [
      'Sciatica & Nerve Compression Pain',
      'Spinal Surgery Rehabilitation',
      'Neurological Motor Dysfunctions',
      'Geriatric Balance & Mobility Services'
    ],
    themeColor: 'navy'
  },
  {
    id: 'sports',
    title: 'Sports Rehabilitation',
    subtitle: 'Athlete & Performance Care',
    description: 'Focused biomechanical sports conditioning and rapid recovery therapies for athletes and active professionals to get back to doing what they love.',
    icon: 'award',
    image: '/assets/ser_cat3.png',
    conditions: [
      'Ligament Injuries (ACL, PCL, MCL, LCL)',
      'Muscle Sprains, Strains & Tears',
      'Golfer’s Elbow & Rotator Cuff Injury',
      'Custom Home Exercise Recovery Programs'
    ],
    themeColor: 'coral'
  }
];

const Specializations = () => {
  return (
    <section id="specializations" className="section bg-white">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-tag">Core Expertise</span>
          <h2 className="section-title">Specialized Rehabilitation</h2>
          <p className="section-subtitle">
            Providing evidence-based physical therapy designed to target the root cause of your pain and deliver lasting physical health.
          </p>
        </div>

        {/* Core Specialities Grid */}
        <div className="grid-3 specialities-grid">
          {specialitiesData.map((spec, index) => (
            <div 
              key={spec.id} 
              className={`spec-card spec-theme-${spec.themeColor}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Top Accent Strip */}
              <div className="spec-card-strip"></div>
              
              {/* Specialty Image */}
              {spec.image && (
                <div className="spec-image-wrapper">
                  <img src={spec.image} alt={spec.title} className="spec-card-image" />
                </div>
              )}
              
              <div className="spec-card-content">
                {/* Header Icon + Subtitle */}
                <div className="spec-card-header">
                  <div className="spec-icon-box">
                    <Icon name={spec.icon} size={26} className="spec-icon" />
                  </div>
                  <div className="spec-header-text">
                    <span className="spec-subtitle">{spec.subtitle}</span>
                    <h3 className="spec-card-title">{spec.title}</h3>
                  </div>
                </div>

                <p className="spec-description">{spec.description}</p>

                {/* Checklist of treated conditions */}
                <div className="spec-conditions-list">
                  <h4>Common Treatments:</h4>
                  <ul>
                    {spec.conditions.map((cond, cIdx) => (
                      <li key={cIdx}>
                        <div className="check-bullet">
                          <Icon name="checkcircle" size={14} className="bullet-icon" />
                        </div>
                        <span>{cond}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specializations;
